module.exports = __webpack_public_path__ + "img/size-estimator_en.ef35f8de.png";